module.exports = __webpack_public_path__ + "img/43b4de7.jpg";